/**
 *
 * @module createPaymentMethodPassthroughData
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

import BillingAddress from './billingAddress';

const {
    number,
    nonEmptyString,
    nonEmptyObject,
    instanceStrict,
    boolean
} = Check.assert;

/**
 *
 * @class CreatePaymentMethodPassthroughData
 *
 */
export default class CreatePaymentMethodPassthroughData {

    /**
     *
     * @param {Object} options
     * @param {String} [options.alternateName=undefined]
     * @param {Number} options.expiryMonth
     * @param {Number} options.expiryYear
     * @param {String} options.ownerFullName
     * @param {Boolean} options.isDefault
     * @param {Boolean} options.isReusable
     * @param {BillingAddress} options.billingAddress
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options = {}) {

        const errorMessage = {
            ctor: 'CreatePaymentMethodPassthroughData(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get alternateName() {
                return `${this.ctor} alternate should be a non-empty String`;
            },
            get expiryMonth() {
                return `${this.ctor} expiryMonth should be a Number`;
            },
            get expiryYear() {
                return `${this.ctor} expiryYear should be a Number`;
            },
            get ownerFullName() {
                return `${this.ctor} ownerFullName should be a non-empty String`;
            },
            get isDefault() {
                return `${this.ctor} isDefault shoudld be a Boolean`;
            },
            get isReusable() {
                return `${this.ctor} isReusable should be a Boolean`;
            },
            get billingAddress() {
                return `${this.ctor} billingAddress should be an instance of SDK.Services.Commerce.BillingAddress`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { alternateName, expiryMonth, expiryYear, ownerFullName } = options;
        const { isDefault, billingAddress, isReusable } = options;

        if (Check.assigned(alternateName)) {
            nonEmptyString(alternateName, errorMessage.alternateName, InvalidArgumentException);
        }

        number(expiryMonth, errorMessage.expiryMonth, InvalidArgumentException);
        number(expiryYear, errorMessage.expiryYear, InvalidArgumentException);
        nonEmptyString(ownerFullName, errorMessage.ownerFullName, InvalidArgumentException);
        boolean(isDefault, errorMessage.isDefault, InvalidArgumentException);
        boolean(isReusable, errorMessage.isReusable, InvalidArgumentException);
        instanceStrict(billingAddress, BillingAddress, errorMessage.isDefault, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.alternateName = alternateName;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.expiryMonth = expiryMonth;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.expiryYear = expiryYear;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.ownerFullName = ownerFullName;

        /**
         *
         * @access public
         * @type {Boolean}
         *
         */
        this.isDefault = isDefault;

        /**
         *
         * @access public
         * @type {String}
         * @note These strings and their format are defined by the service.
         *
         */
        this.usage = isReusable ? 'multi_use' : 'single_use';

        /**
         *
         * @access public
         * @type {BillingAddress}
         *
         */
        this.billingAddress = billingAddress;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/createPaymentMethodPassthroughData.js